import React from 'react';
import glamorous from 'glamorous';

const Values = () => {
  return (
    <div>
      <h4>
        Values
      </h4>
      <glamorous.Ul className="pt-list" css={{ listStyle: 'disc' }}>
        <li>
          All codes should contain 8 digits:
          <glamorous.Ul css={{ listStyle: 'circle' }}>
            <li>First two digits (1-2) denote Segment.</li>
            <li>Next two digits (3-4) denote Family.</li>
            <li>Next two digits (5-6) denote Class.</li>
            <li>Last two digits (7-8) denote Brick.</li>
          </glamorous.Ul>
        </li>
        <li>Brick codes always start with “1”.</li>
        <li>Brick attribute codes always start with “2”.</li>
        <li>Brick attribute value codes always start with “3”.</li>
      </glamorous.Ul>
    </div>
  );
};

export default Values;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/product-codes/values.js